/* eslint-disable class-methods-use-this */

/**
 * Gateway input handler for REST calls
 */
class RESTInputHandler {
  /**
   * The RestInputHandler follows the spec, so no formatting is needed.
   *
   * @param {any} data
   * @returns {any} data
   */
  format(data) {
    return data;
  }
}

export default RESTInputHandler;
